import { useUserProfile } from '@/presentation/hooks/useUserProfile'
import { useCopyLink } from './useCopyLink'
import { computeInviteButtonsDisabled } from './useInviteViewModel.logic'
import { usePromotionLink } from './usePromotionLink'
import { useQRCodeGenerator } from './useQRCodeGenerator'
import { useSaveQRCode } from './useSaveQRCode'
import { useShareQRCode } from './useShareQRCode'

export function useInviteViewModel() {
  const { userProfile, isUserProfileLoading } = useUserProfile()
  const {
    data: promotionData,
    isLoading: isPromotionLoading,
    isError: isPromotionError,
  } = usePromotionLink()
  const { saveQRCode } = useSaveQRCode()
  const { copyLink, copied, error: copyError } = useCopyLink()
  const { share, errorType: shareErrorType } = useShareQRCode()

  const promotionLink = promotionData?.promotion_link || ''
  const { qrCodeDataUrl, posterDataUrl, qrCodeError } =
    useQRCodeGenerator(promotionLink)

  const isButtonsDisabled = computeInviteButtonsDisabled({
    isPromotionLoading,
    isPromotionError,
    qrCodeError,
    hasQrCode: !!qrCodeDataUrl,
    hasPoster: !!posterDataUrl,
  })

  const handleSaveImage = () => {
    saveQRCode(posterDataUrl)
  }

  const handleShareQR = () => {
    share(promotionLink, 'Join us and start earning!')
  }

  const handleCopyLink = () => {
    copyLink(promotionLink)
  }

  return {
    greeting: {
      nickname: userProfile?.nickname,
      isLoading: isUserProfileLoading,
    },
    referralCard: {
      isLoading: isPromotionLoading,
      isError: isPromotionError,
      qrCodeError,
      qrCodeDataUrl,
      isButtonsDisabled,
      onSave: handleSaveImage,
      onShare: handleShareQR,
    },
    linkCard: {
      isLoading: isPromotionLoading,
      promotionLink,
      isButtonsDisabled,
      onCopy: handleCopyLink,
    },
    toasts: {
      copied,
      copyError,
      shareErrorType,
    },
  }
}
